import useLocalStorage from 'react-use-localstorage'

// Custom hook used to avoid being called during SSR
const useSsrLocalStorage = (
  key: string,
  initial: string
): [string, React.Dispatch<string>] => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return typeof window === 'undefined'
    ? [initial, (value: string) => undefined]
    : useLocalStorage(key, initial)
}

export default useSsrLocalStorage
